import React from 'react';
import PropTypes from 'prop-types';
import { MarketplaceConnection } from '@shipstation/connections-ui';
import { noop } from 'ui-components/default-props/noop';
import { useCommonCuiProps } from './helpers/use-common-cui-props';
import { LogService } from '../services/log-service';

const ERROR_CODES_TO_IGNORE = ['GET_MARKETPLACE_CONNECTION_FORM_FAILED'];

export const CuiMarketplaceConnection = ({
  marketplaceApiCode,
  onCancel = noop,
  onSave = noop,
  storeGuid,
  redirectPath = '',
  onBack = noop,
  onError = noop,
  onRedirect = noop,
}) => {
  const commonCuiProps = useCommonCuiProps();

  const onCuiError = (error) => {
    if (!ERROR_CODES_TO_IGNORE.includes(error?.code)) {
      // error is a plain object from the connections-ui iframe (via postMessage), not an Error
      // instance. Sentry can't walk cause chains on plain objects, so we pass fields as extras.
      const displayMessage = error?.message || error?.code || 'unknown';
      LogService.logError(new Error(`Marketplace connection error: ${displayMessage}`, { cause: error }), {
        errorCode: error?.code,
        errorMessage: error?.message,
        errorDetail: error?.error,
        context: error?.context,
      });
    }
    onError(error);
  };

  return (
    <MarketplaceConnection
      {...commonCuiProps}
      marketplaceApiCode={marketplaceApiCode}
      onBack={onBack}
      onCancel={onCancel}
      onError={onCuiError}
      onRedirect={onRedirect}
      onSave={onSave}
      redirectPath={redirectPath}
      storeGuid={storeGuid}
    />
  );
};

CuiMarketplaceConnection.propTypes = {
  marketplaceApiCode: PropTypes.string.isRequired,
  onSave: PropTypes.func,
  onError: PropTypes.func,
  onCancel: PropTypes.func,
  storeGuid: PropTypes.string,
  redirectPath: PropTypes.string,
  onBack: PropTypes.func,
  onRedirect: PropTypes.func,
};
